<div class="container">
  <div class="vertical-products sec-padding">
    <div class="p-0 fx-row xs-fx-col fx-main-start fx-cross-start">
      <div class="product-panel xs-fx-flex-100-in-col gt-xs-fx-flex-33_3 print-fx-flex-100">
        <div class="widget-column">
          <div class="title">
            <h4 class="widget-title">Featured Products</h4>
          </div>
          @if (products?.length > 0) {
            <ul class="product-list">
              @for (product of products | slice:0:3; track product) {
                <li class="fx-row">
                  <div class="media-image">
                    @if (!contentLoaded) {
                      <ngx-skeleton-loader loadingText="Ziplingo"  [theme]="{ width: '80px', height: '80px' }" animation="progress"></ngx-skeleton-loader>
                    }
                    @if (contentLoaded) {
                      <a [routerLink]="['/product', product.ItemID]">
                        <img [default]="'assets/images/product/no-img.png'" style="width: 80px; height: 80px;" [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory/'+product.ImageUrl"  class="small" alt=""> </a>
                      }
                    </div>
                    <div class="media-body">
                      @if (!contentLoaded) {
                        <ngx-skeleton-loader loadingText="Ziplingo"
                          count="3"
                          [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }"
                        ></ngx-skeleton-loader>
                      }
                      @if (contentLoaded) {
                        <a [routerLink]="['/product', product.ItemID]"><span>{{product.ProductName}}</span></a>
                      }
                      @if (contentLoaded) {
                        <div class="stars">
                          <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                          <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                          <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                          <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                          <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                        </div>
                      }
                      @if (contentLoaded) {
                        <p class="price">{{product.Prices[0].Price | currency : companyService.selectedCurrency.CurrencyCode  }}</p>
                      }
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
        </div>
        <div class="product-panel xs-fx-flex-100-in-col gt-xs-fx-flex-33_3 print-fx-flex-100">
          <div class="widget-column">
            <div class="title">
              <h4 class="widget-title">Top Selling Products</h4>
            </div>
            @if (products?.length > 0) {
              <ul class="product-list">
                @for (product of products | slice:6:9 ; track product) {
                  <li class="fx-row">
                    <div class="media-image">
                      @if (!contentLoaded) {
                        <ngx-skeleton-loader loadingText="Ziplingo"  [theme]="{ width: '80px', height: '80px' }" animation="progress"></ngx-skeleton-loader>
                      }
                      @if (contentLoaded) {
                        <a [routerLink]="['/product', product.ItemID]">
                          <img [default]="'assets/images/product/no-img.png'" style="width: 80px; height: 80px;" [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory/'+product.ImageUrl" alt="" class="small" > </a>
                        }
                      </div>
                      <div class="media-body">
                        @if (!contentLoaded) {
                          <ngx-skeleton-loader loadingText="Ziplingo"
                            count="3"
                            [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }"
                          ></ngx-skeleton-loader>
                        }
                        @if (contentLoaded) {
                          <a [routerLink]="['/product', product.ItemID]"><span>{{product.ProductName}}</span></a>
                        }
                        @if (contentLoaded) {
                          <div class="stars">
                            <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                            <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                            <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                            <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                            <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                          </div>
                        }
                        @if (contentLoaded) {
                          <p class="price">{{product.Prices[0].Price | currency : companyService.selectedCurrency.CurrencyCode }}</p>
                        }
                      </div>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
          <div class="product-panel xs-fx-flex-100-in-col gt-xs-fx-flex-33_3 print-fx-flex-100">
            <div class="widget-column">
              <div class="title">
                <h4 class="widget-title">Hot Offer</h4>
              </div>
              @if (products?.length > 0) {
                <ul class="product-list">
                  @for (product of products | slice:9:12 ; track product) {
                    <li class="fx-row">
                      <div class="media-image">
                        @if (!contentLoaded) {
                          <ngx-skeleton-loader loadingText="Ziplingo"  [theme]="{ width: '80px', height: '80px' }" animation="progress"></ngx-skeleton-loader>
                        }
                        @if (contentLoaded) {
                          <a>
                            <img [routerLink]="['/product', product.ItemID]" style="width: 80px; height: 80px;" [default]="'assets/images/product/no-img.png'" [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory/'+product.ImageUrl"  class="small" alt=""> </a>
                          }
                        </div>
                        <div class="media-body">
                          @if (!contentLoaded) {
                            <ngx-skeleton-loader loadingText="Ziplingo"
                              count="3"
                              [theme]="{ width: '170px', 'border-radius': '0', height: '15px' }"
                            ></ngx-skeleton-loader>
                          }
                          @if (contentLoaded) {
                            <a [routerLink]="['/product', product.ItemID]"><span>{{product.ProductName}}</span></a>
                          }
                          @if (contentLoaded) {
                            <div class="stars">
                              <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                              <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                              <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                              <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                              <mat-icon class="mat-icon-xs mat-icon material-icons ng-star-inserted">star_rate</mat-icon>
                            </div>
                          }
                          @if (contentLoaded) {
                            <p class="price">{{product.Prices[0].Price | currency : companyService.selectedCurrency.CurrencyCode }}</p>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
        </div>
      </div>